import { Component, OnInit, ViewChild } from '@angular/core';
import { Faq } from '@hm_app/@core/models/info';
import * as _ from 'lodash-es';

@Component({
    selector: 'ngx-ricerca-faq',
    templateUrl: './ricerca-faq.component.html',
    styleUrls: ['./ricerca-faq.component.scss'],
})
export class RicercaFaqComponent implements OnInit {


    _faqs: Faq[];

    filtered_faqs: Faq[];

    @ViewChild('search', { static: true }) search: any;

    set faqs(f: Faq[]) {
        this._faqs = f;
    }
    get faqs(): Faq[] {
        return this._faqs;
    }

    constructor() { }

    ngOnInit() {
    }

    filterFaqs() {
        const s = this.search.nativeElement.value;
        this.filtered_faqs = _.filter(this.faqs, function (f) {
            if (_.includes(f.domanda.it, s)) {
                return f;
            }
        });
    }

}
